import type { ProviderSeedlist, ProviderSeedlistResponse } from '../types';

export function providerSeedlistMapper(response: ProviderSeedlistResponse): ProviderSeedlist {
  return {
    providerCount: response.provider_count,
    providerInvalidCount: response.provider_invalid_count ?? 0,
    fetchedAt: response.fetched_at,
    // `null` until this environment applies its first sync.
    lastSyncedAt: response.last_synced_at ?? null,
    toAdd: response.to_add ?? [],
    toRemove: (response.to_remove ?? []).map((entry) => ({ seedId: entry.seed_id, email: entry.email })),
  };
}
